export const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export const GUTTERS = ['top', 'right', 'bottom', 'left'];
export const GUTTER_SIZES = [
  'none',
  'quarter',
  'half',
  'normal',
  'onehalf',
  'double',
  'triple'
];
export const HORIZONTAL_GUTTER_SIZES = GUTTER_SIZES;
export const VERTICAL_GUTTER_SIZES = GUTTER_SIZES;
export const MAX_COLS = 12;
export const COL_SIZES = [...Array(MAX_COLS).keys()].reduce((sizes, n) => {
  const incrementedN = n + 1;
  sizes[`COL_${incrementedN}`] = incrementedN;
  return sizes;
}, {});

export const gutterShape = {
  top: null,
  right: null,
  bottom: null,
  left: null
};

export const breakpointGutterShape = {
  xs: gutterShape,
  sm: gutterShape,
  md: gutterShape,
  lg: gutterShape,
  xl: gutterShape,
  xxl: gutterShape
};
